export default {
  get: {

  },
  post: {
    // 获取客户下有效的协议列表
    getPurchaseAppointList: "/appoint/get-valid-appoint-list", 
    // 协议基础信息详情
    getAppointBaseInfoById: "/appoint/get-detail-by-appoint-no",
    // 协议商品列表
    getAppointGoodsList: "/appoint/get-goods-by-appoint-no"
  }
}